import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16890fee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "today-agree__head" }
const _hoisted_2 = {
  class: "d-flex align-center",
  style: {"gap":"8px"}
}
const _hoisted_3 = { class: "today-agree__title" }
const _hoisted_4 = { class: "today-agree__lead" }
const _hoisted_5 = { class: "today-start-steps" }
const _hoisted_6 = ["aria-current"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "today-start-step__no" }, "1", -1))
const _hoisted_8 = ["aria-current"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "today-start-step__no" }, "2", -1))
const _hoisted_10 = { class: "today-start-use" }
const _hoisted_11 = { class: "today-start-use__value" }
const _hoisted_12 = { class: "today-start-hint" }
const _hoisted_13 = { class: "label" }
const _hoisted_14 = { class: "text-body-2 text-grey mt-2 mb-0" }
const _hoisted_15 = { class: "text-body-2 text-grey mt-1 mb-0" }
const _hoisted_16 = { class: "label" }
const _hoisted_17 = { class: "text-body-2 text-grey mt-2 mb-0" }
const _hoisted_18 = { class: "today-start-note" }
const _hoisted_19 = {
  class: "today-start-error text-body-2 text-error",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_TodayDeliveryAgreementPanel = _resolveComponent("TodayDeliveryAgreementPanel")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": _ctx.state.open,
    "max-width": "760",
    scrollable: "",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "today-agree td-keep-words" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.msg.title), 1),
              (_ctx.agreementVersion)
                ? (_openBlock(), _createBlock(_component_v_chip, {
                    key: 0,
                    size: "x-small",
                    variant: "tonal"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("약관 버전 " + _toDisplayString(_ctx.agreementVersion), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.msg.lead), 1),
            _createElementVNode("ol", _hoisted_5, [
              _createElementVNode("li", {
                class: _normalizeClass(["today-start-step", { 'is-current': _ctx.step === 1, 'is-done': _ctx.step === 2 }]),
                "aria-current": _ctx.step === 1 ? 'step' : undefined
              }, [
                _hoisted_7,
                _createTextVNode(_toDisplayString(_ctx.msg.stepSettings), 1)
              ], 10, _hoisted_6),
              _createElementVNode("li", {
                class: _normalizeClass(["today-start-step", { 'is-current': _ctx.step === 2 }]),
                "aria-current": _ctx.step === 2 ? 'step' : undefined
              }, [
                _hoisted_9,
                _createTextVNode(_toDisplayString(_ctx.msg.stepAgreement), 1)
              ], 10, _hoisted_8)
            ])
          ]),
          _createVNode(_component_v_divider),
          (_ctx.step === 1)
            ? (_openBlock(), _createBlock(_component_v_card_text, {
                key: 0,
                class: "today-start__body"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_v_switch, {
                      "model-value": true,
                      color: "success",
                      readonly: "",
                      "hide-details": "",
                      density: "compact",
                      class: "flex-grow-0",
                      "aria-label": _ctx.policyMsg.useLabel
                    }, null, 8, ["aria-label"]),
                    _createElementVNode("span", null, [
                      _createTextVNode(_toDisplayString(_ctx.policyMsg.useLabel) + " ", 1),
                      _createElementVNode("strong", _hoisted_11, _toDisplayString(_ctx.msg.useValue), 1)
                    ]),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.msg.useHint), 1)
                  ]),
                  _createVNode(_component_v_row, { class: "mt-2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.policyMsg.cutoffLabel), 1),
                          _createVNode(_component_v_select, {
                            modelValue: _ctx.form.order_cutoff_time,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.order_cutoff_time) = $event)),
                            class: "today-start__cutoff",
                            items: _ctx.cutoffSelectItems,
                            disabled: _ctx.busy || !_ctx.cutoffChangeAvailable,
                            density: "compact",
                            "hide-details": "",
                            "aria-label": "주문 마감시각"
                          }, null, 8, ["modelValue", "items", "disabled"]),
                          _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.policyMsg.cutoffAvailableHint), 1),
                          _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.policyMsg.weekdayNotice), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.policyMsg.soldoutLabel), 1),
                          _createVNode(_component_v_select, {
                            modelValue: _ctx.form.default_soldout_action,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.default_soldout_action) = $event)),
                            class: "today-start__soldout",
                            items: _ctx.soldoutSelectItems,
                            disabled: _ctx.busy,
                            density: "compact",
                            "hide-details": "",
                            "aria-label": _ctx.policyMsg.soldoutLabel
                          }, null, 8, ["modelValue", "items", "disabled", "aria-label"]),
                          _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.policyMsg.soldoutHint), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.msg.exampleNote), 1)
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_TodayDeliveryAgreementPanel, {
                key: 1,
                agreement: _ctx.agreement,
                cutoff: _ctx.form.order_cutoff_time,
                "onUpdate:complete": _cache[2] || (_cache[2] = ($event: any) => (_ctx.agreementComplete = $event))
              }, null, 8, ["agreement", "cutoff"])),
          (_ctx.message)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createVNode(_component_v_divider),
                _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.message), 1)
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_card_actions, { class: "today-agree__foot" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              (_ctx.step === 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_v_btn, {
                      class: "today-start__cancel",
                      variant: "text",
                      disabled: _ctx.busy,
                      onClick: _ctx.cancel
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.msg.cancel), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"]),
                    _createVNode(_component_v_btn, {
                      class: "today-start__next",
                      color: "primary",
                      variant: "flat",
                      disabled: _ctx.busy,
                      onClick: _ctx.next
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.msg.next), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_v_btn, {
                      class: "today-start__back",
                      variant: "text",
                      disabled: _ctx.busy,
                      onClick: _ctx.back
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.msg.back), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"]),
                    _createVNode(_component_v_btn, {
                      class: "today-start__start",
                      color: "primary",
                      variant: "flat",
                      loading: _ctx.busy,
                      disabled: !_ctx.canStart,
                      onClick: _ctx.start
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.msg.start), 1)
                      ]),
                      _: 1
                    }, 8, ["loading", "disabled", "onClick"])
                  ], 64))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}